import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const formulariFormDatiAccettazione : AnaColumn[]= [

    {
      itemType: "group", groupDataField: 'datiAccettazione', caption: 'Dati accettazione rifiuto', colCount: "2", data: [
  
  
        {
          type: 'campoSpecial', colVisible: false, dataField: 'accettazioneCompleta', dataType: "", hideOnEdit: false, caption: "Tipo Accettazione",
          width: 50 * aspect,
          editorType: 'dxSelectBox',
          lista: {
            dataSource: 'accettazioneTipo',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: true
          },
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
  
        {
          type: 'campo', colVisible: false, dataField: 'quantitaAccettataValore', dataType: "", hideOnEdit: false, caption: "Quantità Accettata",
          width: 15 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
        {
          type: 'campoSpecial', colVisible: false, dataField: 'quantitaAccettataUm', dataType: "", hideOnEdit: false, caption: 'Unità misura',
          editorType: 'dxSelectBox',
          width: 13.5 * aspect,
          lista: {
            dataSource: 'um',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: true
          },
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
  
        {
          type: 'campo', colVisible: false, dataField: 'motivazioniRespingimento', dataType: "", hideOnEdit: false, caption: "Respinto per",
          width: 50 * aspect,
  
        },
        { type: 'empty', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, },
  
        {
          type: 'campoData', caption: 'Accettato in data', colVisible: false, dataField: 'dataAccettazione', dataType: "datetime", editorType: 'dxDateBox', hideOnEdit: false,
          format: "dd/MM/yyyy",
          width: 15 * aspect,
          
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
  
  
        {
          type: 'campoData', caption: 'Alle ore', colVisible: false, dataField: 'oraAccettazione', dataType: "time", editorType: 'dxDateBox', hideOnEdit: false,
          format: 'HH:mm',
          width: 13.5 * aspect,
          validation: [
            { type: "required", message: "Campo Obbligatorio" }
          ],
        },
  
  
        {
          type: 'campo', colVisible: false, dataField: 'annotazioni', dataType: "", hideOnEdit: false, caption: "Annotazioni", editorType: 'dxTextArea',
          width: 50 * aspect,
  
        },
  
      ]
  
    },
  ]